import styled from 'styled-components';
import { EmptyState } from 'ui/emptyState';
import { ErrorStatePageError } from 'ui/illustrations';
import { spacing, RouterLink } from 'ui/theme';

const Wrapper = styled.div`
  padding: ${spacing.x3} ${spacing.base};
`;

export const MemberNotFound = () => (
  <Wrapper>
    <EmptyState
      Illustration={ErrorStatePageError}
      title="That’s unexpected!"
      subtitle={
        <>
          We had a problem finding this user. Try{' '}
          <RouterLink to="/members">returning to the organizations members page</RouterLink>.
        </>
      }
    />
  </Wrapper>
);
